<template>
  <app-client-layout title="Information">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        お知らせ詳細
      </h2>
    </template>
    <div class="px-4 py-4 mx-auto w-full max-w-5xl">
      <div class="shadow overflow-hidden sm:rounded-md">
        <div class="px-4 py-5 bg-white sm:p-6">
          <p class="text-xs whitespace-pre-wrap text-white bg-indigo-400 px-4 py-1 rounded-lg text-center inline md:text-sm md:w-32 md:block">
            {{ informationCategories[props.information.category_id] }}
          </p>

          <h3 class="text-md whitespace-pre-wrap my-6">
            {{ props.information.subject }}
          </h3>

          <p class="text-md my-6 whitespace-pre-wrap">
            {{ props.information.description }}
          </p>
        </div>
      </div>
      <div class="px-4 py-3 flex justify-between sm:px-6">
        <div>
          <button
            class="py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-500 hover:bg-grey-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-grey-500"
            @click="onClickedBack">
            戻る
          </button>
        </div>
      </div>
    </div>
  </app-client-layout>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import {
  computed,
} from 'vue'
import AppClientLayout from '@/Layouts/AppClientLayout'

const props = defineProps({
  information: {
    type: Object,
    default: () => ({ id: null }),
  },
})

const informationCategories = computed(() => usePage().props.value.informationCategories)

const onClickedBack = () => {
  Inertia.get(route('client-information'))
}

</script>
<style scoped>
  @import '../../../../css/heading.css';
</style>
